export const bookingSettingsGetters = {
  bookingSettingsData: state => state.bookingSettingsData,
  rssList: state => state.rssList
};
